import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '@service/notification.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { EmailInfoStorage } from '@storage/mailbox/email-info.storage';
import { UserSettingsStorage } from '@storage/settings/user-settings.storage';
import { TranslatorService } from '@service/translator/translator.service';
import { LocalSettingsKey } from '@shared/types/local-settings';
import { RefreshTokenService } from '@service/rest/refresh-token/refresh-token.service';
import { ConfigsService } from '@service/rest/config/configs.service';
import { SettingsInfoService } from '@service/rest/settings/settings-info.service';
import { ProfilePhotoCacheService } from '@service/rest/profile-photo/profile-photo-cache.service';
import { SessionProfileRefreshersStorage } from '@storage/session-profile-refreshers.storage';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit, OnDestroy {
    userSettings: any;
    checkTokenTimer;
    profileRefresherSubscription: Subscription;

    @HostListener('window:beforeunload', ['$event'])
    beforeUnloadHandler() {
        if (this.refreshTokenService.isTokenRenewingOnCurrentTab()) {
            localStorage.removeItem(LocalSettingsKey.IS_TOKEN_RENEWING);
        }
    }

    constructor(
        public deviceDetectorService: DeviceDetectorService,
        private settingsInfoService: SettingsInfoService,
        private configsService: ConfigsService,
        private notificationService: NotificationService,
        private translateService: TranslateService,
        private emailInfoStorage: EmailInfoStorage,
        private userSettingsStorage: UserSettingsStorage,
        private sessionProfileRefreshersStorage: SessionProfileRefreshersStorage,
        private translatorService: TranslatorService,
        private refreshTokenService: RefreshTokenService,
        private profilePhotoCacheService: ProfilePhotoCacheService
    ) {
        this.checkTokenTimer = setInterval(() => {
            this.refreshTokenService.checkTokens();
        }, 60000);
    }

    ngOnInit() {
        this.getSettings();
        this.getPreferences();
        this.getEmailInformation();
        this.listenProfileRefresher();
    }

    ngOnDestroy(): void {
        this.emailInfoStorage.refreshEmailInfo(false);
        clearInterval(this.checkTokenTimer);
        this.profileRefresherSubscription?.unsubscribe();
    }

    getSettings(): void {
        this.settingsInfoService.getSettings().subscribe(
            data => {
                this.userSettings = data;
                this.userSettingsStorage.setUserSettings(data);
                this.userSettingsStorage.refreshUserSettings(true);
                this.setLanguage();
                this.getProfileImage();
            },
            error => {
                // TODO: this.notificationService.showError(this.translateService.instant(error.error.message));
            }
        );
    }

    setLanguage(): void {
        const language: string = this.userSettings.language || this.translatorService.getSelectedLanguage()?.code || 'tr';
        if (this.translatorService.getSelectedLanguage()?.code !== language) {
            this.translatorService.useLanguage(language);
            this.translatorService.setDefaultLanguage();
        }
    }

    getProfileImage(): any {
        const email = JSON.parse(localStorage.getItem(LocalSettingsKey.USER)).username;
        this.profilePhotoCacheService.getCachedPhotoByEmail(email, true).subscribe(
            (data) => {
                if (data) {
                    this.userSettings.imageBase64 = data;
                    this.profilePhotoCacheService.evictCachedPhoto(email);
                    this.userSettingsStorage.refreshUserSettings(true);
                    this.userSettingsStorage.refreshProfilePhoto();
                    this.userSettingsStorage.setUserSettings(this.userSettings);
                }
            },
            error => { }
        );
    }

    getPreferences(): void {
        this.configsService.getPreferences().subscribe(
            data => {
                localStorage.setItem(LocalSettingsKey.PREFERENCES, JSON.stringify(data));
            }
        );
    }

    getEmailInformation(): void {
        this.settingsInfoService.getEmailInformation().subscribe(
            data => {
                this.emailInfoStorage.setEmailInfo(data);
                this.emailInfoStorage.refreshEmailInfo(true);
            },
            error => {
                this.notificationService.showError(this.translateService.instant(error.errors.error.message));
            }
        );
    }

    listenProfileRefresher(): void {
        this.profileRefresherSubscription = this.sessionProfileRefreshersStorage.listenProfileRefresher().subscribe(data => {
          if (data) {
            this.getSettings();
          }
        });
      }
}
